<template>
	<button type="button" @click="modalOpen = true">
		<slot></slot>
		<portal to="modals" v-if="modalOpen" :order="3">
			<new-product-modal
				:cat-id="catId"
				:show="modalOpen"
				@close="modalOpen = false"
			></new-product-modal>
		</portal>
	</button>
</template>

<script>
import NewProductModal from './NewProductModal.vue'

export default {
	props: ['catId'],
	components: {
		NewProductModal
	},
	data () {
		return {
			modalOpen: false
		}
	}
}
</script>
